(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    function initVariantPicker(card) {
    const dataScript = card.querySelector('.merch-variant-data');
    if (!dataScript) return;

    let data;
    try {
      data = JSON.parse(dataScript.textContent);
    } catch (err) {
      console.error('Error parsing variant data for product card:', err);
      return;
    }

    const variants = data.variants || [];
    const selects = Array.from(card.querySelectorAll('.variant-select'));
    if (selects.length === 0) return;

    const selected = Object.assign({}, data.selectedOptions || {});

    const idInput = card.querySelector('.merch-variant-id-input');
    const addToCartButton = card.querySelector('.merch-item-btn');
    const priceEl = card.querySelector('.merch-price');
    const quantityField = card.querySelector('.merch-quantity-field');
    const quantitySelect = card.querySelector('.quantity-select');
    const quantityInput = card.querySelector('.quantity-input');

    function variantMatchesOtherSelections(variant, ignorePosition) {
      return Object.keys(selected).every((position) => {
        if (position === String(ignorePosition)) return true;
        return variant.options[Number(position) - 1] === selected[position];
      });
    }

    function isValueAvailable(position, value) {
      return variants.some((variant) => {
        if (!variant.available) return false;
        if (variant.options[Number(position) - 1] !== value) return false;
        return variantMatchesOtherSelections(variant, position);
      });
    }

    function findMatchingVariant() {
      return variants.find((variant) =>
        Object.keys(selected).every((position) => variant.options[Number(position) - 1] === selected[position]),
      );
    }

    function applyVariant(variant) {
      const isComplete =
        Object.keys(selected).length > 0 &&
        Object.values(selected).every((value) => value !== null && value !== undefined);

      if (idInput) {
        idInput.value = variant ? variant.id : '';
      }
      if (addToCartButton) {
        addToCartButton.setAttribute('data-variant-id', variant ? variant.id : '');
      }
      if (priceEl && variant && variant.priceFormatted) {
        priceEl.textContent = variant.priceFormatted;
      }

      const imgWrapper = card.querySelector('.merch-product-image-wrapper');
      const imgEl = imgWrapper ? imgWrapper.querySelector('img') : null;
      if (imgEl && variant && variant.featuredImageSrc) {
        imgEl.srcset = '';
        imgEl.src = variant.featuredImageSrc;
      }

      if (quantityField && quantitySelect) {
        const inventoryQuantity = variant ? variant.inventoryQuantity : 0;
        if (variant && inventoryQuantity > 1) {
          quantityField.hidden = false;
          const currentValue = quantitySelect.value;
          quantitySelect.innerHTML = '';
          for (let num = 1; num <= inventoryQuantity; num += 1) {
            const optionEl = document.createElement('option');
            optionEl.value = String(num);
            optionEl.textContent = String(num);
            quantitySelect.appendChild(optionEl);
          }
          if (Number(currentValue) <= inventoryQuantity) {
            quantitySelect.value = currentValue;
          }
          if (quantityInput) quantityInput.value = quantitySelect.value;
        } else {
          quantityField.hidden = true;
          if (quantityInput) quantityInput.value = '1';
        }
      }

      if (addToCartButton) {
        if (variant && variant.available) {
          addToCartButton.classList.remove('is-disabled');
          updateButtonState();
        } else {
          addToCartButton.classList.add('is-disabled');
          addToCartButton.disabled = true;
          addToCartButton.innerText = isComplete ? 'UNAVAILABLE' : 'SELECT OPTIONS';
        }
      }
    }

    function render() {
      selects.forEach((select) => {
        const position = select.getAttribute('data-option-position');

        Array.from(select.options).forEach((optionEl) => {
          optionEl.disabled = !isValueAvailable(position, optionEl.value);
        });

        if (selected[position] !== undefined && select.value !== selected[position]) {
          select.value = selected[position];
        }
      });

      applyVariant(findMatchingVariant());
    }

    selects.forEach((select) => {
      select.addEventListener('change', () => {
        const position = select.getAttribute('data-option-position');
        selected[position] = select.value;

        selects.forEach((otherSelect) => {
          const otherPosition = otherSelect.getAttribute('data-option-position');
          if (otherPosition === position) return;
          if (isValueAvailable(otherPosition, selected[otherPosition])) return;

          const fallback = Array.from(otherSelect.options).find((optionEl) =>
            isValueAvailable(otherPosition, optionEl.value),
          );
          if (fallback) {
            selected[otherPosition] = fallback.value;
          }
        });

        render();
      });
    });

    render();
  }

  function initVariantPickers() {
    document.querySelectorAll('[data-product-card-id]').forEach(initVariantPicker);
  }

  const merchForms = document.querySelectorAll('form');
  merchForms.forEach((merchForm) => {
    merchForm.addEventListener('submit', async (e) => {
      e.preventDefault();

      const formData = new FormData(merchForm);

      await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        body: formData,
      })
        .then((res) => {
          return res.json();
        })
        .then(async () => {
          const res = await fetch(window.Shopify.routes.root + 'cart.js');
          const cart = await res.json();
          updateButtonState(cart);
          updateCartCount(cart);
        })
.catch((err) => {
  console.error('Error posting req for adding item to cart: ', err);
});
    });
  });

  async function updateButtonState(cartData) {
    const buttons = document.querySelectorAll('.merch-item-btn');

    try {
      const cart = cartData || await (await fetch(window.Shopify.routes.root + 'cart.js')).json();

      buttons.forEach((button) => {
        const variantId = parseInt(button.getAttribute('data-variant-id'));
        const cartItem = cart.items.find((item) => item.variant_id === variantId);
        const card = button.closest('[data-product-card-id]');

        if (cartItem) {
          button.disabled = true;
          button.innerText = 'ALREADY IN CART';
          button.classList.add('is-disabled');
          if (card) {
            card.dataset.inCartKey = cartItem.key;
            const quantityField = card.querySelector('.merch-quantity-field');
            const quantitySelect = card.querySelector('.quantity-select');
            if (quantityField && !quantityField.hidden && quantitySelect) {
              quantitySelect.value = String(cartItem.quantity);
              const quantityInput = card.querySelector('.quantity-input');
              if (quantityInput) quantityInput.value = String(cartItem.quantity);
            }
          }
        } else {
          button.disabled = false;
          button.innerText = 'ADD TO CART';
          button.classList.remove('is-disabled');
          if (card) delete card.dataset.inCartKey;
        }
      });
    } catch (error) {
      console.error('Error fetching cart:', error);
    }
  }

  async function updateCartCount(cartData) {
    const cart = cartData || await (await fetch(window.Shopify.routes.root + 'cart.js')).json();

    const cartCount = document.getElementById('cart-count');
    if (cartCount) {
      cartCount.textContent = cart.item_count;
    }

    const cartLink = document.getElementById('cart-link');
    if (cartLink) {
      cartLink.setAttribute('aria-label', `Cart, ${cart.item_count} items`);
    }
  }

  document.querySelectorAll('.quantity-select').forEach((select) => {
    select.addEventListener('change', async function () {
      const statusBar = this.closest('.status-bar');
      const hiddenInput = statusBar ? statusBar.querySelector('.quantity-input') : null;
      if (hiddenInput) hiddenInput.value = this.value;

      const card = this.closest('[data-product-card-id]');
      const inCartKey = card ? card.dataset.inCartKey : null;
      if (inCartKey) {
        try {
          const res = await fetch(window.Shopify.routes.root + 'cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: inCartKey, quantity: parseInt(this.value) }),
          });
          const cart = await res.json();
          updateCartCount(cart);
        } catch (err) {
          console.error('Error updating cart quantity:', err);
        }
      }
    });
  });

  document.addEventListener('DOMContentLoaded', () => {
    initVariantPickers();
    updateButtonState();
  });
  } catch(e) { console.error(e); }
})();

})();
